import Tag from './tag';
import CheckableTag from './checkable-tag';
var DefaultTag = Tag;
DefaultTag.CheckableTag = CheckableTag;
export default DefaultTag;
//# sourceMappingURL=index.js.map